<!-- player.html -->
<div
  #playerElement
  class="tshirt-container"
  cdkDrag
  [cdkDragBoundary]="bounds"
  (cdkDragStarted)="onStarted($event)"
  (cdkDragEnded)="onDropped($event)"
  (cdkDragMoved)="change($event)"
  (click)="onTap($event)"
  [ngStyle]="{
    position: 'absolute',
    top: player?.cY + 'px',
    left: player?.cX + 'px'
  }"
>
  <div #shirtImage  cdkDragHandle class="shirt-wrapper" style="transform: scale(1.4)">
    <svg-tshirt-container
      [style$]="player?.style"
      [type$]="player?.type"
    ></svg-tshirt-container>
    <div class="tshirt-description">
      <div class="name">{{ player?.name }}</div>
    </div>
  </div>
</div>